import request from '@/utils/request'

// 查询店铺名称logo等修改记录审核信息列表
export function listShopRecord(query) {
  return request({
    url: '/shop/shop/record/list',
    method: 'get',
    params: query
  })
}

// 查询店铺名称logo等修改记录审核信息详细
export function getShopRecord(id) {
  return request({
    url: '/shop/shop/record/' + id,
    method: 'get'
  })
}

// 新增店铺名称logo等修改记录审核信息
export function addShopRecord(data) {
  return request({
    url: '/shop/shop/record',
    method: 'post',
    data: data
  })
}

// 修改店铺名称logo等修改记录审核信息
export function updateShopRecord(data) {
  return request({
    url: '/shop/shop/record',
    method: 'put',
    data: data
  })
}

// 审核店铺基础信息状态
export function auditShopInfoStatus(data) {
  return request({
    url: '/shop/shop/record/audit/info',
    method: 'put',
    data: data
  })
}

// 删除店铺名称logo等修改记录审核信息
export function delShopRecord(id) {
  return request({
    url: '/shop/shop/record/' + id,
    method: 'delete'
  })
}
